import { render, staticRenderFns } from "./podcast-item.vue?vue&type=template&id=429cdbd4&"
import script from "./podcast-item.vue?vue&type=script&lang=js&"
export * from "./podcast-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports